import { useSelector } from "react-redux";
import { applyFilterByMainKeyAndSlug, clearFilterByKeyAndSelectionIndex, clearAllFilter, clearFilterByKey } from "../store/slice/model/ProductListingFilterApplied";
import store from "../storeWire";
import { setSettings } from "../store/slice/model/ProductListingSettings";
import { loadData } from "../store/slice/model/ProductListingFilterBoxSelection";

export function useProductFilterStore() {
    const filterList = useSelector((state) => state.entities.ProductListingFilterApplied)
    const filterBoxSelection = useSelector((state) => state.entities.ProductListingFilterBoxSelection)
    const filterBoxExpanded = useSelector((state) => state.entities.ProductListingSettings.filter_box_expanded);
    const filterBoxActiveSelection = useSelector((state) => state.entities.ProductListingFilterBoxActiveSelection);
    const compactView = useSelector((state) => state.entities.ProductListingSettings.compact_view)

    let data = {
        filterList,
        filterBoxSelection,
        filterBoxExpanded,
        compactView,
        filterBoxActiveSelection
    };

    let fetch = {
        load_product_listing_filterbox_active_selection: (params) => {
            return store.dispatch(loadData(params));
        }
    };
    let set = {
        apply_product_filter: async (params) => {
            return await store.dispatch(applyFilterByMainKeyAndSlug(params))
        },

        clear_product_filter: async (params) => {
            return await store.dispatch(clearFilterByKeyAndSelectionIndex(params))
        },

        clear_product_filter_by_key: async (params) => {
            return await store.dispatch(clearFilterByKey(params))
        },

        clear_all_product_filter: () => {
            return store.dispatch(clearAllFilter())
        },

        apply_product_setting: (params) => {
            return store.dispatch(setSettings(params));
        },

        update_product_listing_filterbox_active_selection: (params) => {
            const filterBoxSelection = {}
            if (params.status) {
                filterBoxSelection[params.selection.slug] = params.selection;
            } else {
                delete filterBoxSelection[action.payload.selection.slug];
            }
            return filterBoxSelection
        }

    };
    let operations = {

    };

    return [data, fetch, set, operations]
}